import React from 'react';
import { testimonials } from '../../constants/content';
import { Testimonial } from '../../types';

const isVideoEntry = (entry: Testimonial): entry is Testimonial & { youtubeId: string } => Boolean(entry.youtubeId);

const Testimonials: React.FC = () => {
  return (
    <section className="py-16 bg-contessa-100">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-contessa-900 mb-4">
            Experiencias
          </h2>
          <p className="text-contessa-700 max-w-2xl mx-auto">
            Conocé las historias de algunas de las familias que han confiado en mi acompañamiento.
          </p>
          <div className="w-24 h-1 bg-contessa-300 mx-auto mt-6"></div>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-4">
          {testimonials.map((entry) =>
            isVideoEntry(entry) ? (
              <article key={`video-${entry.id}`} className="break-inside-avoid-column mb-4">
                <div className="bg-white rounded-xl p-6 shadow-md flex flex-col gap-4">
                  <div className="rounded-xl overflow-hidden bg-contessa-50">
                    <div className="relative aspect-[9/16] w-full">
                      <iframe
                        title={entry.title || `video-${entry.id}`}
                        src={`https://www.youtube-nocookie.com/embed/${entry.youtubeId}?controls=1&rel=0&modestbranding=1&playsinline=1`}
                        className="absolute inset-0 w-full h-full"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    </div>
                  </div>
                  {(entry.title || entry.description || entry.name) && (
                    <div>
                      {entry.title ? (
                        <h4 className="font-bold text-contessa-800 text-base">{entry.title}</h4>
                      ) : entry.name ? (
                        <h4 className="font-bold text-contessa-800 text-base">{entry.name}</h4>
                      ) : null}
                      {entry.description && <p className="text-contessa-500 text-xs">{entry.description}</p>}
                    </div>
                  )}
                </div>
              </article>
            ) : (
              <article key={`testimonial-${entry.id}`} className="break-inside-avoid-column mb-4">
                <div className="bg-white rounded-xl p-6 shadow-md">
                  {entry.content && <p className="text-contessa-600 italic text-sm mb-4">"{entry.content}"</p>}
                  <div className="mt-auto">
                    <h4 className="font-bold text-contessa-800 text-base">{entry.name}</h4>
                    {entry.role && <p className="text-contessa-500 text-xs">{entry.role}</p>}
                  </div>
                </div>
              </article>
            )
          )}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
